import { format } from '~/util/date';

/**
 * Gets today's date formatted as dd-MM-yyyy
 * Normalizes to start of day to avoid timezone issues
 */
const getTodayFormatted = (): string => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Normalize to start of day
  return format(today, 'dd-MM-yyyy');
};

export default getTodayFormatted;
